<!--/ FILTER BAR -->
<app-filter-bar [showFiscalYearFilter]="false" [showClientPoFilter]="true" [showPurchaseOrderCount]="false" [statusOptions]="allStatuses" [billingStatuses]="allBillingStatuses" [jobTypes]="allJobTypes" [engagementLeads]="allEngagementLeads" [buyers]="allBuyers" [programManagers]="allProgramManagers" [clientLeads]="allClientLeads" [parentJobCodes]="parentJobCodes" [jobCodes]="allJobCodes" [projectTypes]="allProjectTypes" [clientPoNumbers]="filteredClientPOs" [selectedClientPoNumbers]="selectedClientPOs" [selectedStatuses]="selectedStatuses" [selectedBillingStatuses]="selectedBillingStatuses" [selectedJobTypes]="selectedJobTypes" [selectedEngagementLeads]="selectedEngagementLeads" [selectedBuyers]="selectedBuyers" [selectedProgramManagers]="selectedPMs" [selectedParentJobCodes]="selectedParentJobCodes" [selectedJobCodes]="selectedJobCodes" [selectedClientLeads]="selectedClientLeads" [selectedProjectTypes]="selectedProjectTypes" [projectCount]="(projects$ | async)?.length || 0" [searchTerm]="searchTerm" (statusChange)="onCheckboxChange('status', $event.value, $event.checked)" (billingStatusChange)="onCheckboxChange('billing', $event.value, $event.checked)" (jobTypeChange)="onCheckboxChange('jobType', $event.value, $event.checked)" (engagementLeadChange)="onCheckboxChange('engagementLead', $event.value, $event.checked)" (buyerChange)="onCheckboxChange('buyer', $event.value, $event.checked)" (programManagerChange)="onCheckboxChange('pm', $event.value, $event.checked)" (clientLeadChange)="onCheckboxChange('clientLead', $event.value, $event.checked)" (clientPoChange)="onCheckboxChange('clientPo', $event.value, $event.checked)" (parentJobCodeChange)="onParentJobCodeChange($event.value, $event.checked)" (jobCodeChange)="onJobCodeChange($event.value, $event.checked)" (projectTypeChange)="onCheckboxChange('projectType', $event.value, $event.checked)" (resetFiltersEvent)="resetFilters()" (searchChange)="onSearchChange($event)">
</app-filter-bar>

<div class="projects-container">
  <div class="content">
    <div class="main container-fluid m-0 p-0">
      <h1 class="d-inline-block m-0 p-0">Projects</h1>
      <button class="btn btn-export btn-xls btn-sm ms-3 align-middle" style="vertical-align:middle;" (click)="exportProjectsXLSX()">XLS</button>
      <button class="btn btn-export btn-pdf btn-sm ms-2 align-middle" style="vertical-align:middle;" (click)="exportProjectsPDF()">PDF</button>
      <button class="btn btn-export btn-csv btn-sm ms-2 align-middle" style="vertical-align:middle;" (click)="exportProjectsCSV()">CSV</button>
    </div>
    <p class="as-of mb-4">
      as of
      <ng-container *ngIf="(clickup_all_transformed_last_success$ | async) as ts; else na">
        {{ ts | date:'MM-dd-yy' }} at {{ ts | date:'HH:mm' }} {{ userTimeZone }}
      </ng-container>
      <ng-template #na>n/a</ng-template>
    </p>
    <ng-container *ngIf="projects$ | async as projects">
      <div style="margin-bottom: 16px;">
        <a href="#" (click)="$event.preventDefault(); openAllAccordions(projects)">Open All</a>
        &nbsp;|&nbsp;
        <a href="#" (click)="$event.preventDefault(); closeAllAccordions()">Close All</a>
        &nbsp;|&nbsp;
        <a href="#" (click)="$event.preventDefault(); resetFilters()" style="color:#d55;font-weight:600">Reset Filters</a>
      </div>
      <div class="projects-table-container">
        <div class="accordion-scroll-container">
          <div class="accordion" id="projectsAccordion">

            <!--/ HEADER -->
            <div class="accordion-item accordion-header-row sticky-header">
              <div class="accordion-bar">
                <!--~ Updated Header -->
                <div class="updated header" (click)="setSort('updatedDate')" style="cursor:pointer;">
                  Updated
                  <span *ngIf="sortField === 'updatedDate'" class="sort-indicator active-sort">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
                </div>
                <!--~ Billing Status Header -->
                <div class="billing-status header" (click)="setSort('billingStatus')" style="cursor:pointer;">
                  Billing Status
                  <span *ngIf="sortField === 'billingStatus'" class="sort-indicator active-sort">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
                </div>
                <!--~ Job Type Header -->
                <div class="job-type header" (click)="setSort('jobType')" style="cursor:pointer;">
                  Job <br>Type
                  <span *ngIf="sortField === 'jobType'" class="sort-indicator active-sort">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
                </div>
                <!--~ Job Code Header -->
                <div class="job-code header" (click)="setSort('jobCode')" style="cursor:pointer;">
                  Job <br>Code
                  <span *ngIf="sortField === 'jobCode'" class="sort-indicator active-sort">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
                </div>
                <!--~ Project Name Header -->
                <div class="project-name header" (click)="setSort('projectName')" style="cursor:pointer;">
                  Project Name
                  <span *ngIf="sortField === 'projectName'" class="sort-indicator active-sort">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
                </div>
                <!--~ ClickUp Status Header -->
                <div class="clickup-status header" (click)="setSort('status')" style="cursor:pointer;">
                  ClickUp <br>Status
                  <span *ngIf="sortField === 'status'" class="sort-indicator active-sort">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
                </div>
                <!--~ Progress Header  -->
                <div class="progress-container header" (click)="setSort('progress')" style="cursor:pointer;">
                  <span class="long">Progress</span><span class="short">Prog</span>
                  <span *ngIf="sortField === 'progress'" class="sort-indicator active-sort">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
                </div>
                <!--~ Program Manager Header  -->
                <div class="program-manager header" (click)="setSort('programManager')" style="cursor:pointer;">
                  <span class="long">Program Manager</span>
                  <span class="short">PM</span>
                  <span *ngIf="sortField === 'programManager'" class="sort-indicator active-sort">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
                </div>
                <!--~ Engagement Lead Header  -->
                <div class="engagement-lead header" (click)="setSort('engagementLead')" style="cursor:pointer;">
                  <span class="long">Engagement Lead</span>
                  <span class="short">EL</span>
                  <span *ngIf="sortField === 'engagementLead'" class="sort-indicator active-sort">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
                </div>
                <!--~ Client Lead Header  -->
                <div class="client-lead header" (click)="setSort('clientLead')" style="cursor:pointer;">
                  <span class="long">Client Lead</span>
                  <span class="short">CL</span>
                  <span *ngIf="sortField === 'clientLead'" class="sort-indicator active-sort">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
                </div>
              </div>
            </div>

            <!--| CONTENT / ACCORDION ITEM -->
            <div class="accordion-item" *ngFor="let task of projects; let i = index; trackBy: trackByProjectId">
              <ng-container *ngIf="task.projectName || task.taskName || task.jobCode || task.progress !== null; else blankTask">
                <h2 class="accordion" [id]="'heading' + i">
                  <button class="accordion-button custom-accordion-bar" type="button" [class.collapsed]="!openedTaskIds.includes(task.taskId)" [attr.aria-expanded]="openedTaskIds.includes(task.taskId)" (click)="toggleAccordion(task.taskId)">
                    <span class="accordion-bar">
                      <!--# UPDATED -->
                      <div class="updated cell">
                        <ng-container *ngIf="isValidDate(task['updatedDate']); else showUpdatedRaw">
                          {{ task['updatedDate'] | date:'MM-dd-yy'}}
                        </ng-container>
                        <ng-template #showUpdatedRaw>{{ task['updatedDate'] }}</ng-template>
                      </div>
                      <!--# BILLING STATUS  -->
                      <div class="billing-status cell">
                        <span class="pill billing-status-pill" [style.backgroundColor]="task['billingStatusCellColor'] || '#ddd' " [style.color]="task['billingStatusTextColor']">{{ task['billingStatus'] || '&nbsp;'}}
                        </span>
                      </div>
                      <!--# JOB TYPE -->
                      <div class="job-type cell">
                        <span class="pill job-type-pill" [style.backgroundColor]="task['jobTypeCellColor'] || '#ddd'" [style.color]="task['jobTypeTextColor']">{{ task['jobType'] || '&nbsp;' }}</span>
                      </div>
                      <!--# Job Code -->

                      <div class="job-code cell">{{ task.jobCode }}
                      </div>
                      <!--# PROGRESS -->

                      <div class="project-name cell">{{ task.projectName || task.taskName }}
                      </div>
                      <!--# ClickUp Status -->

                      <div class="clickup-status cell">
                        <span class="pill clickup-status-pill" [style.backgroundColor]="task['statusCellColor']" [style.color]="task['statusTextColor']">{{ task.status }}
                        </span>
                      </div>
                      <!--# JOB-PROGRESS -->

                      <!--\\  -->
                      <div class="progress-container cell">

                        <!-- Desktop view with bar -->
                        <div class="progress-outer">
                          <div class="progress-bg">
                            <div class="progress-bar" [style.width.%]="task.progress || 0" [class.low-value]="(task.progress || 0) < 30" [class.zero-progress]="(task.progress || 0) === 0">

                              <!-- Label is inside for higher percentages -->
                              <span class="progress-label" *ngIf="(task.progress || 0) >= 30">{{task.progress}}%</span>
                            </div>

                            <!-- Label is outside for low percentages -->
                            <span class="progress-label-outside" *ngIf="(task.progress || 0) < 30">{{task.progress}}%</span>
                          </div>
                        </div>

                        <!-- Mobile view text only -->
                        <div class="progress-mobile">
                          {{task.progress}}%
                        </div>
                      </div>
                      <!--# PROGRAM MANAGER -->
                      <div class="program-manager cell">
                        <span class="long">{{ replaceGeneralAdmin(task['programManager']) || '—' }}</span>
                        <span class="short">{{ task['programManagerInitials'] || '—' }}</span>
                      </div>
                      <!--# ENGAGEMENT LEAD -->
                      <div class="engagement-lead cell">
                        <span class="long">{{ cbAdminFix(task['engagementLead']) || '—' }}</span>
                        <span class="short">{{ task['engagementLeadInitials'] || '—' }}</span>
                      </div>
                      <!--# CLIENT LEAD -->
                      <div class="client-lead cell">
                        <span>{{ task['clientLead'] || '—' }}</span>
                      </div>

                    </span>
                  </button>
                </h2>
                <div [id]="'collapse' + i" class="accordion-collapse" [class.show]="openedTaskIds.includes(task.taskId)" [attr.aria-labelledby]="'heading' + i">

                  <!--/ BODY -->
                  <div class="accordion-body">

                    <!--| DATES -->
                    <div class="panel dates-panel">
                      <div class="eyebrow panel-eyebrow">Dates</div>
                      <div class="field-container top">
                        <div class="label">Fiscal Year</div>
                        <div class="value date">
                          <ng-container *ngIf="isValidDate(task['fiscalYear']); else showFiscalYearRaw">
                            {{ task['fiscalYear']}}
                          </ng-container>
                          <ng-template #showFiscalYearRaw>{{ task['fiscalYear'] }}</ng-template>
                        </div>
                      </div>

                      <div class="field-container">
                        <div class="label">Created</div>
                        <div class="value date">
                          <ng-container *ngIf="isValidDate(task['createdDate']); else showCreatedRaw">
                            {{ task['createdDate'] | date:'MM-dd-yy' }}
                          </ng-container>
                          <ng-template #showCreatedRaw>{{ task['createdDate'] }}</ng-template>
                        </div>
                      </div>

                      <div class="field-container">
                        <div class="label">Start</div>
                        <div class="value date">
                          <ng-container *ngIf="isValidDate(task['startDate']); else showStartRaw">
                            {{ task['startDate'] | date:'MM-dd-yy' }}
                          </ng-container>
                          <ng-template #showStartRaw>{{ task['startDate'] }}</ng-template>
                        </div>
                      </div>

                      <div class="field-container">
                        <div class="label">Due</div>
                        <div class="value date">
                          <ng-container *ngIf="isValidDate(task['dueDate']); else showDueRaw">
                            {{ task['dueDate'] | date:'MM-dd-yy' }}
                          </ng-container>
                          <ng-template #showDueRaw>{{ task['dueDate'] }}</ng-template>
                        </div>
                      </div>

                      <div class="field-container">
                        <div class="label">Updated</div>
                        <div class="value date">
                          <ng-container *ngIf="isValidDate(task['updatedDate']); else showUpdatedRaw">
                            {{ task['updatedDate'] | date:'MM-dd-yy'}}
                          </ng-container>
                          <ng-template #showUpdatedRaw>{{ task['updatedDate'] }}</ng-template>
                        </div>
                      </div>
                    </div>

                    <!--| LINKS -->
                    <div class="panel links-panel">
                      <div class="eyebrow panel-eyebrow">Links</div>
                      <div class="field-container">
                        <!--# Brief -->
                        <ng-container *ngIf="task['briefUrl']; else briefOff">
                          <a href="{{ task['briefUrl'] }}" target="_blank" rel="noopener">
                            <span class="icon-tooltip">
                              <span aria-label="Project Brief">
                                <img src="assets/icons/icon-brief-ON.svg" alt="Brief" class="project-link-icon" />
                              </span>
                            </span>
                          </a>
                        </ng-container>
                        <ng-template #briefOff>
                          <span class="icon-tooltip off">
                            <span aria-label="Project Brief">
                              <img src="assets/icons/icon-brief-OFF.svg" alt="Brief (none)" class="project-link-icon off" />
                            </span>
                          </span>
                        </ng-template>
                        <!--# Dropbox -->
                        <ng-container *ngIf="task['dropboxUrl']; else dropboxOff">
                          <div class="link-icon">
                            <a href="{{ task['dropboxUrl'] }}" target="_blank" rel="noopener">
                              <span class="icon-tooltip">
                                <span aria-label="Dropbox Folder">
                                  <img src="assets/icons/icon-dropbox-ON.svg" alt="Dropbox" class="project-link-icon" />
                                </span>
                              </span>
                            </a>

                          </div>
                        </ng-container>
                        <ng-template #dropboxOff>
                          <span class="icon-tooltip off">
                            <span aria-label="Dropbox Folder">
                              <img src="assets/icons/icon-dropbox-OFF.svg" alt="Dropbox (none)" class="project-link-icon off" />
                            </span>
                          </span>
                        </ng-template>
                        <!--# Figma -->
                        <ng-container *ngIf="task['figmaUrl']; else figmaOff">
                          <a href="{{ task['figmaUrl'] }}" target="_blank" rel="noopener">
                            <span class="icon-tooltip">
                              <span aria-label="Figma Doc">
                                <img src="assets/icons/icon-figma-ON.svg" alt="Figma" class="project-link-icon" />
                              </span>
                            </span>
                          </a>
                        </ng-container>
                        <ng-template #figmaOff>
                          <span class="icon-tooltip off">
                            <span aria-label="Figma Doc">
                              <img src="assets/icons/icon-figma-OFF.svg" alt="Figma (none)" class="project-link-icon off" />
                            </span>
                          </span>
                        </ng-template>
                        <!--# GDrive -->
                        <ng-container *ngIf="task['gdriveUrl']; else gdriveOff">
                          <a href="{{ task['gdriveUrl'] }}" target="_blank" rel="noopener">
                            <span class="icon-tooltip">
                              <span aria-label="Google Drive Folder">
                                <img src="assets/icons/icon-drive-ON.svg" alt="Google Drive" class="project-link-icon" />
                              </span>
                            </span>
                          </a>
                        </ng-container>
                        <ng-template #gdriveOff>
                          <span class="icon-tooltip off">
                            <span aria-label="Google Drive Folder">
                              <img src="assets/icons/icon-drive-OFF.svg" alt="Google Drive (none)" class="project-link-icon off" />
                            </span>
                          </span>
                        </ng-template>
                        <!--# Frame -->
                        <ng-container *ngIf="task['frameUrl']; else frameOff">
                          <a href="{{ task['frameUrl'] }}" target="_blank" rel="noopener">
                            <span class="icon-tooltip">
                              <span aria-label="Frame.io Project">
                                <img src="assets/icons/icon-frame-ON.svg" alt="Frame" class="project-link-icon" />
                              </span>
                            </span>
                          </a>
                        </ng-container>
                        <ng-template #frameOff>
                          <span class="icon-tooltip off">
                            <span aria-label="Frame.io Project">
                              <img src="assets/icons/icon-frame-OFF.svg" alt="Frame (none)" class="project-link-icon off" />
                            </span>
                          </span>
                        </ng-template>
                        <!--# ClickUp Task -->
                        <ng-container *ngIf="task['taskId']; else clickupOff">
                          <a [href]="'https://app.clickup.com/t/' + task['taskId']" target="_blank" rel="noopener">
                            <span class="icon-tooltip">
                              <span aria-label="ClickUp Task">
                                <img src="assets/icons/icon-clickup-task-ON.svg" alt="ClickUp Task" class="project-link-icon" />
                              </span>
                            </span>
                          </a>
                        </ng-container>
                        <ng-template #clickupOff>
                          <span class="icon-tooltip off">
                            <span aria-label="ClickUp Task">
                              <img src="assets/icons/icon-clickup-task-OFF.svg" alt="ClickUp Task (none)" class="project-link-icon off" />
                            </span>
                          </span>
                        </ng-template>
                        <!--# ClickUp Space -->
                        <ng-container *ngIf="task['spaceId']; else clickupSpaceOff">
                          <a [href]="'https://app.clickup.com/9014243918/v/o/s/' + task['spaceId']" target="_blank" rel="noopener">
                            <span class="icon-tooltip">
                              <span aria-label="ClickUp Space">
                                <img src="assets/icons/icon-clickup-space-ON.svg" alt="ClickUp Space" class="project-link-icon" />
                              </span>
                            </span>
                          </a>
                        </ng-container>
                        <ng-template #clickupSpaceOff>
                          <span class="icon-tooltip off">
                            <span aria-label="ClickUp Space">
                              <img src="assets/icons/icon-clickup-space-OFF.svg" alt="ClickUp Space (none)" class="project-link-icon off" />
                            </span>
                          </span>
                        </ng-template>
                        <!--# ClickUp Folder -->
                        <ng-container *ngIf="task['folderId']; else clickupFolderOff">
                          <a [href]="'https://app.clickup.com/9014243918/v/o/f/' + task['folderId']" target="_blank" rel="noopener">
                            <span class="icon-tooltip">
                              <span aria-label="ClickUp Folder">
                                <img src="assets/icons/icon-clickup-folder-ON.svg" alt="ClickUp Folder" class="project-link-icon" />
                              </span>
                            </span>
                          </a>
                        </ng-container>
                        <ng-template #clickupFolderOff>
                          <span class="icon-tooltip off">
                            <span aria-label="ClickUp Folder">
                              <img src="assets/icons/icon-clickup-folder-OFF.svg" alt="ClickUp Folder (none)" class="project-link-icon off" />
                            </span>
                          </span>
                        </ng-template>
                        <!--# ClickUp List -->
                        <ng-container *ngIf="task['listId']; else clickupListOff">
                          <a [href]="'https://app.clickup.com/9014243918/v/li/' + task['listId']" target="_blank" rel="noopener">
                            <span class="icon-tooltip">
                              <span aria-label="ClickUp List">
                                <img src="assets/icons/icon-clickup-list-ON.svg" alt="ClickUp List" class="project-link-icon" />
                              </span>
                            </span>
                          </a>
                        </ng-container>
                        <ng-template #clickupListOff>
                          <span class="icon-tooltip off">
                            <span aria-label="ClickUp List">
                              <img src="assets/icons/icon-clickup-list-OFF.svg" alt="ClickUp List (none)" class="project-link-icon off" />
                            </span>
                          </span>
                        </ng-template>
                        <!--# Sharepoint -->
                        <ng-container *ngIf="task['sharepointUrl']; else sharepointOff">
                          <a href="{{ task['sharepointUrl'] }}" target="_blank" rel="noopener">
                            <span class="icon-tooltip">
                              <span aria-label="Sharepoint Site">
                                <img src="assets/icons/icon-sharepoint-ON.svg" alt="Sharepoint" class="project-link-icon" />
                              </span>
                            </span>
                          </a>
                        </ng-container>
                        <ng-template #sharepointOff>
                          <span class="icon-tooltip off">
                            <span aria-label="Sharepoint Site">
                              <img src="assets/icons/icon-sharepoint-OFF.svg" alt="Sharepoint (none)" class="project-link-icon off" />
                            </span>
                          </span>
                        </ng-template>
                        <!--# Final Deliverables -->
                        <ng-container *ngIf="task['finalDeliverables']; else finalDeliverablesOff">
                          <a href="{{ task['finalDeliverables'] }}" target="_blank" rel="noopener">
                            <span class="icon-tooltip">
                              <span aria-label="Final Deliverables">
                                <img src="assets/icons/icon-final-deliverables-ON.svg" alt="Final Deliverables" class="project-link-icon" />
                              </span>
                            </span>
                          </a>
                        </ng-container>
                        <ng-template #finalDeliverablesOff>
                          <span class="icon-tooltip off">
                            <span aria-label="Final Deliverables">
                              <img src="assets/icons/icon-final-deliverables-OFF.svg" alt="Final Deliverables (none)" class="project-link-icon off" />
                            </span>
                          </span>
                        </ng-template>
                      </div>
                      <div class="booleans">
                        <div class="foundry"> <span class="value">
                            <input type="checkbox" [checked]="task['theFoundryProject']" disabled aria-label="Foundry Project" />
                          </span>
                          <span class="label">Foundry</span>

                        </div>
                        <div class="archived"> <span class="value">
                            <input type="checkbox" [checked]="task['archived']" disabled aria-label="Archived Project" />
                          </span>
                          <span class="label">Archived</span>

                        </div>
                      </div>

                    </div>


                    <!--| PEOPLE -->
                    <div class="panel people-panel">
                      <div class="eyebrow panel-eyebrow">People</div>
                      <div class="field-container top">
                        <div class="label">PM</div>
                        <div class="value">{{ replaceGeneralAdmin(task['programManager']) }}</div>
                      </div>
                      <div class="field-container">
                        <div class="label">EL</div>
                        <div class="value">{{ cbAdminFix(task['engagementLead']) }}</div>
                      </div>
                      <div class="field-container">
                        <div class="label">CL</div>
                        <div class="value">{{ task['clientLead'] }}</div>
                      </div>
                    </div>


                    <!--| DETAILS -->
                    <div class="panel details-panel">
                      <div class="project eyebrow panel-eyebrow">Details</div>
                      <div class="field-container top">
                        <div class="label topline-update">Topline Update</div>
                        <div class="value topline-update">{{ task['toplineUpdate'] }}
                        </div>
                      </div>
                      <div class="field-container">
                        <div class="label details">Buyer</div>
                        <span class="value string">{{ task['buyer'] }}</span>
                      </div>
                      <div class="field-container">
                        <div class="label">Project Type</div>
                        <div class="value string">{{ task['projectType'] }}</div>
                      </div>

                      <!-- <div class="field-container">
                        <div class="label">Practice Area</div>
                        <div class="data string">{{ task['practiceArea'] }}</div>
                      </div> -->

                      <div class="field-container">
                        <div class="label">PO</div>
                        <div class="value">
                          {{ task['clientPo'] }}
                        </div>
                      </div>
                      <div class="field-container">
                        <div class="label">Time Est</div>
                        <div class="value">
                          <ng-container *ngIf="isValidDate(task['timeEstimate']); else showTimeRaw">
                            {{ task['timeEstimate'] | date:'HH:mm'}}
                          </ng-container>
                          <ng-template #showTimeRaw>{{ task['timeEstimate'] }}</ng-template>
                        </div>
                      </div>





                    </div>



                  </div>
                </div>
              </ng-container>
            </div>




            <ng-template #blankTask>
              <div style="color: #bbb; font-style: italic; padding: 1em;">
                [Blank task]
              </div>
            </ng-template>
          </div>

          <!-- .accordion -->

        </div>
        <div class="resize-handle projects-resize-handle" (mousedown)="startResize($event, 'projects')"></div>
      </div>